import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types";

import { CheckoutFormSection } from "../../../../CheckoutFormSection";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../../constants";
import { buildRemainingPayments } from "./helpers";
import { InstallmentsLines } from "./InstallmentsLine";

export interface RemainingPaymentsPreviewProps {
  className?: string;
  preview: PaywallCheckoutPreview;
  variant?: keyof typeof DEFAULT_FULL_PREVIEW_VARIANT;
}

export const RemainingPaymentsPreview = ({
  preview,
  className,
  variant,
}: RemainingPaymentsPreviewProps) => {
  if (
    variant === DEFAULT_FULL_PREVIEW_VARIANT.default ||
    preview.paywall_price.price_type !== "installments"
  ) {
    return null;
  }

  const newPreview: PaywallCheckoutPreview = {
    ...preview,
    remaining_payments: buildRemainingPayments(preview),
  };

  if (!newPreview?.remaining_payments) {
    return null;
  }

  return (
    <CheckoutFormSection className={classNames("gap-y-2 border-t", className)}>
      <InstallmentsLines.TitleLine preview={newPreview} />
      <InstallmentsLines.DiscountedInstallmentsLine preview={newPreview} />
      <InstallmentsLines.StandardInstallmentsLine preview={newPreview} />
    </CheckoutFormSection>
  );
};
